import axios from "axios";
import { apiConfiguration } from "plumbing/api";
import { serialize } from "object-to-formdata";

export const createActivityShare = (id: number, request: { image: Blob }) => {
  const url = `${apiConfiguration.apiUrl}/activities/${id}/shares`;
  const formData = serialize(request);
  return axios.post(url, formData);
};
